import React, {
	useState,
} from 'react';
import Select from 'react-select';

import style from './Users.module.css';
import TextSmall from 'Vulture/Field/TextSmall';

import {
	buildTestData,
} from 'Vulture/TestData.js';

import {
	providerListToModalContent,
	getProviderConfig,
} from './listingIntegrationModels';

import {
	fetchPlacewiseMalls,
} from 'Vulture/Listing';

const styles = {
	control: (base) => {
		return {
			...base,
			maxHeight: 30,
		};
	},
	dropdownIndicator: (base) => {
		return {
			...base,
			paddingTop:    0,
			paddingBottom: 0,
		};
	},
	clearIndicator: (base) => {
		return {
			...base,
			paddingTop:    0,
			paddingBottom: 0,
		};
	},
	menu: (base) => {
		return {
			...base,
			top:      20,
			position: 'absolute',
		};
	},
};

const ListingIntegrationModal = (props) => {
	const {
		closeModal,
		accountUUID,
		listingConfigUUID,
		provider,
		providerList,
		onCredentialsSet,
		app,
	} = props;

	const [ email, setEmail, ] = useState('');
	const [ authCode, setAuthCode, ] = useState('');
	const [ key, setKey, ] = useState('');
	const [ mallID, setMallID, ] = useState('');
	const [ mapID, setMapID, ] = useState('');
	const [ loyaltyClubSlug, setLoyaltyClubSlug, ] = useState('');
	const [ mallOptions, setMallOptions, ] = useState([]);
	const [ errorMsg, setErrorMsg, ] = useState('');
	const [ isSubmitting, setIsSubmitting, ] = useState(false);

	const {
		fields,
	} = getProviderConfig(provider);

	const authenticate = async () => {
		if (isSubmitting) {
			return;
		}

		setErrorMsg('');
		setIsSubmitting(true);

		let listingConfigFD;
		try {
			listingConfigFD = await app.registerListingIntegration({
				accountUUID,
				listingConfigUUID,
				provider,
				integrationList: providerList,
				email,
				authCode,
				key,
				mallID: loyaltyClubSlug, // Use loyaltyClubSlug value for mallID field
				mapID,
			});
		} catch (err) {
			setErrorMsg(`Could not set credentials: ${err.message}`);
			setIsSubmitting(false);

			return;
		}

		// The response is the config's server truth — hand it back so the tier's
		// credential gates (Crawl) reconcile now rather than on the next reload.
		if (onCredentialsSet) {
			onCredentialsSet(listingConfigFD);
		}

		closeModal();
	};

	return (
		<div className={style.userModal}>
			<div className={style.integrationInputsContainer}>
				{props.hasSetCredentials && (
					<div className={style.hasCredentialsWarning}>There are already set credentials. Setting new ones will override the previous credentials.</div>
		        )}
				{'email' in fields && <>
					<div className={style.label}>{fields.email}</div>
					<TextSmall
						className={style.select}
						value={email}
						setValue={(e) => {
							setEmail(e);
						}}
						dataTestingInfo={buildTestData('integration-email')}
					/>
				</>}
				{'authCode' in fields && <>
					<div className={style.label}>{fields.authCode}</div>
					<TextSmall
						className={style.select}
						value={authCode}
						setValue={(e) => {
							setAuthCode(e);
							if (provider === 'placewise' && email && e) {
								fetchPlacewiseMalls(email, e)
									.then((malls) => {
										setMallOptions(malls);
									});
							}
						}}
						dataTestingInfo={buildTestData('integration-auth-code')}
					/>
				</>}
				{'key' in fields && <>
					<div className={style.label}>{fields.key}</div>
					<TextSmall
						className={style.select}
						value={key}
						setValue={(e) => {
							setKey(e);
						}}
						dataTestingInfo={buildTestData('integration-auth-code')}
					/>
				</>}
				{'mallID' in fields && <>
					<div className={style.label}>{fields.mallID}</div>
					<Select
						options={mallOptions}
						styles={styles}
						onChange={(newType) => {
							setMallID(newType.value);
						}}
						value={mallOptions.find((option) => {
							return option.value === mallID;
						}) || null}
						isClearable
					/>
				</>}
				{'mapID' in fields && <>
					<div className={style.label}>{fields.mapID}</div>
					<TextSmall
						className={style.select}
						value={mapID}
						setValue={(e) => {
							setMapID(e);
						}}
						dataTestingInfo={buildTestData('integration-email')}
					/>
				</>}
				{'loyaltyClubSlug' in fields && <>
					<div className={style.label}>{fields.loyaltyClubSlug}</div>
					<TextSmall
						className={style.select}
						value={loyaltyClubSlug}
						setValue={(e) => {
							setLoyaltyClubSlug(e);
						}}
						dataTestingInfo={buildTestData('integration-loyalty-club-slug')}
					/>
				</>}
				{errorMsg && (
					<div
						className={style.credentialsError}
						data-testing-info={buildTestData('integration-error')}
					>
						{errorMsg}
					</div>
				)}
				<br/>
				<button
					className={`button ${style.button} ${isSubmitting ? 'button-disabled no-click' : ''}`}
					key='add-tier-btn'
					onClick={(e) => {
						e.preventDefault();
						authenticate();
					}}
					data-testing-info={buildTestData('button--tier')}
					data-test-id='listingIntegrationLogInButton'
					disabled={isSubmitting}
				>
					{isSubmitting ? 'Validating...' : 'Log In'}
				</button>
			</div>
		</div>
	);
};

export default ListingIntegrationModal;